import { render, staticRenderFns } from "./SelectYearSeminars.vue?vue&type=template&id=574f423e&scoped=true"
import script from "./SelectYearSeminars.vue?vue&type=script&lang=js"
export * from "./SelectYearSeminars.vue?vue&type=script&lang=js"
import style0 from "./SelectYearSeminars.vue?vue&type=style&index=0&id=574f423e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574f423e",
  null
  
)

export default component.exports